export default __webpack_public_path__ + "img/tom_windish_&_priya_ps-1fe650846558c51b419b0328326e9854.png";